/**
 * SectionCard Component - Reusable card wrapper using shadcn Card
 * 
 * Provides consistent card styling across the application.
 * Replaces the repeated pattern: <div className="bg-card border border-border rounded-lg p-6">
 * 
 * @example
 * <SectionCard title="Section Title" description="Section description">
 *   Content here
 * </SectionCard>
 */
import { memo } from 'react';
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface SectionCardProps {
  title?: string;
  description?: string;
  children?: React.ReactNode;
  className?: string;
  headerActions?: React.ReactNode;
  padding?: string;
}

export const SectionCard = memo(function SectionCard({
  title,
  description,
  children,
  className,
  headerActions,
  padding = "p-6"
}: SectionCardProps) {
  return (
    <Card className={cn("border-border", className)}>
      {(title || description || headerActions) && (
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              {title && <CardTitle>{title}</CardTitle>}
              {description && <CardDescription>{description}</CardDescription>}
            </div>
            {headerActions && <div>{headerActions}</div>}
          </div>
        </CardHeader>
      )}
      <CardContent className={cn(padding)}>{children}</CardContent>
    </Card>
  );
});
